import styled from "styled-components";

export const ModalWrapperStyle = styled.div`
  position: absolute;
`;
